var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverRightArrowMobi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h768v510H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#115E67",
    xlinkHref: "#a",
    transform: "translate(-261 -314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 4.994c0 .496.392.898.876.898h12.102l-2.015 2.056a.93.93 0 0 0 .018 1.293.877.877 0 0 0 1.26-.018l3.505-3.592a.901.901 0 0 0 .184-.296.864.864 0 0 0 0-.683.901.901 0 0 0-.184-.296L12.742.764a.864.864 0 0 0-1.244 0 .918.918 0 0 0 0 1.275l1.98 2.057H1.376a.887.887 0 0 0-.876.898z",
    fill: "#C4DAD5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRightArrowMobi);
export default __webpack_public_path__ + "static/media/silver-right-arrow-mobi.4b03b8eb2651c310455414f72dd6fa07.svg";
export { ForwardRef as ReactComponent };